export const boardApis = {
    getboardList: "v1/api/boardName",
    getboardListV2:'v1/api/marksheetVerification/getBoards',
    getboardLists: "v1/api/boardName/duplicate",
    createboard: "v1/api/boardName",
    getboardbyId: "v1/api/boardName/",
    updateboardById: "v1/api/boardName?boardId=:boardID",
    updateboardbyId: "v1/api/boardName/update/",
}
